module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--leaderboard"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline qa-leaderboard-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.participantPosition !== null) ? _c('div', {
    staticClass: "c-card--leaderboard__summary",
    class: _vm.rankDigits
  }, [_c('span', {
    staticClass: "c-card--leaderboard__summary__rank u-no-wrap t-rank qa-leaderboard-my-rank"
  }, [_c('i', {
    staticClass: "fa fa-trophy c-card--leaderboard__summary__rank__icon t-ranked-trophy"
  }), _vm._v(_vm._s(_vm.formatNumber(_vm.participantPosition + 1)) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "c-card--leaderboard__summary__rank-of u-no-wrap"
  }, [_vm._v("\n        of " + _vm._s(_vm.formatNumber(_vm.card.recordsTotal)) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.card.description !== null) ? _c('div', {
    staticClass: "c-card--leaderboard__description qa-leaderboard-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.card.description))])]) : _vm._e(), _vm._v(" "), (_vm.dataNotAvailable) ? _c('h2', {
    staticClass: "c-card--leaderboard__missing-data qa-description-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.card_leaderboard.data_not_available')) + "\n    ")]) : _c('table', {
    staticClass: "c-card--leaderboard__table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.card.headers), function(field) {
    return _c('th', [_vm._v("\n            " + _vm._s(field) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.leaderboards), function(record) {
    return _c('tr', [(record === '...') ? _c('td', {
      staticClass: "c-card--leaderboard__collapsed-row",
      attrs: {
        "colspan": _vm.columnsLength
      }
    }, [_vm._v("…")]) : _vm._e(), _vm._v(" "), (record !== '...') ? _c('td', {
      staticClass: "c-card--leaderboard__rank t-leaderboard-rank",
      class: _vm.myPosition(record, 1) ? 'qa-leaderboard-my-row-rank' : ''
    }, [_vm._v(_vm._s(_vm.formatNumber((record + 1))))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reportData[_vm.card.report_id][record]), function(field, index) {
      return (record !== '...' && typeof field.id === 'undefined') ? _c('td', {
        staticClass: "c-card--leaderboard__table__row",
        class: _vm.myPosition(record, index) ? 'qa-leaderboard-my-row-name' : ''
      }, [_vm._v("\n            " + _vm._s(_vm.formatFieldValue(field, index)) + "\n            "), (_vm.myPosition(record, index)) ? _c('span', {
        staticClass: "fa fa-check-circle\n                             c-card--leaderboard__table__icon__row__me\n                             t-leaderboard-rank\n                             qa-leaderboard-my-row-icon",
        attrs: {
          "aria-hidden": "false"
        }
      }, [_c('i', {
        staticClass: "u-hide"
      }, [_vm._v(_vm._s(_vm.$t('web.card_leaderboard.hidden_you_indicator')))])]) : _vm._e()]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer u-center-content"
  }, [_c('button', {
    staticClass: "c-button-expand-card qa-leaderboard-open-modal",
    on: {
      "click": function($event) {
        return _vm.openLeaderboardModal()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_leaderboard.button_open_full_list')) + "\n         "), _c('i', {
    staticClass: "fa fa-plus-square"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc76570"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Leaderboard.vue
// module id = 538
// module chunks = 1